import React, { useEffect, useState } from 'react';
import { motion, LayoutGroup, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, MailIcon, MenuIcon, XIcon } from 'lucide-react';
import { portfolioItems } from '../data/portfolioData';
const tabs = [{
  id: 'home',
  label: 'Startseite',
  path: '/',
  icon: <HomeIcon className="w-4 h-4 mr-1" data-id="element-79" />,
  color: 'bg-gray-100',
  textColor: 'text-gray-800',
  hoverClass: 'hover:bg-gray-50 hover:text-gray-800'
}, {
  id: 'video',
  label: 'Video',
  path: '/video',
  color: 'bg-indigo-100',
  textColor: 'text-indigo-600',
  hoverClass: 'hover:bg-indigo-50 hover:text-indigo-600'
}, {
  id: 'photo',
  label: 'Foto',
  path: '/photo',
  color: 'bg-rose-100',
  textColor: 'text-rose-600',
  hoverClass: 'hover:bg-rose-50 hover:text-rose-600'
}, {
  id: 'motion',
  label: 'Motion Design',
  path: '/motion',
  color: 'bg-teal-100',
  textColor: 'text-teal-600',
  hoverClass: 'hover:bg-teal-50 hover:text-teal-600'
}];
const Header = () => {
  const location = useLocation();
  const [projectName, setProjectName] = useState<string>('');
  const currentPath = location.pathname;
  const getActiveTabColor = () => {
    if (location.pathname.includes('/project/')) {
      return 'bg-amber-100';
    }
    const activeTab = tabs.find(tab => tab.path === location.pathname);
    return activeTab ? activeTab.color : 'bg-gray-100';
  };
  const getActiveTabTextColor = () => {
    const activeTab = tabs.find(tab => tab.path === location.pathname);
    return activeTab ? activeTab.textColor : 'text-gray-800';
  };
  useEffect(() => {
    if (location.pathname.includes('/project/')) {
      const slug = location.pathname.split('/project/')[1];
      const project = portfolioItems.find(item => item.title.toLowerCase().replace(/\s+/g, '-') === slug);
      if (project) {
        setProjectName(project.title);
      }
    } else {
      setProjectName('');
    }
  }, [location.pathname]);
  const handleContactClick = () => {
    window.location.href = 'mailto:Nicolas.lehnert@outlook.de';
  };
  const logoText = 'nickszusehen';
  const logoLetters = logoText.split('');
  return <motion.header initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="fixed w-full z-50 backdrop-blur-xl bg-white/80 border-b border-gray-100/20" data-id="element-80">
      <div className="container mx-auto px-4 py-4" data-id="element-81">
        <div className="flex items-center justify-between" data-id="element-82">
          <Link to="/" className="z-50" data-id="element-83">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2
          }} className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 flex overflow-hidden" data-id="element-84">
              {logoLetters.map((letter, index) => <motion.span key={index} className="inline-block" whileHover={{
              x: index === 0 ? 0 : index * 2,
              transition: {
                type: 'spring',
                stiffness: 300,
                damping: 20
              }
            }} data-id="element-85">
                  {letter}
                </motion.span>)}
            </motion.div>
          </Link>
          <nav className="hidden md:flex items-center space-x-1 p-2 bg-white/50 rounded-3xl backdrop-blur-sm shadow-sm border border-gray-100/20" data-id="element-86">
            <LayoutGroup data-id="element-87">
              {tabs.map(tab => <motion.div key={tab.id} className="relative" initial={false} data-id="element-88">
                  <Link to={tab.path} className={`px-4 py-2 rounded-2xl text-base font-medium flex items-center relative z-10
                      transition-all duration-300 ease-out
                      ${currentPath === tab.path ? tab.textColor : 'text-gray-600'}`} data-id="element-89">
                    {tab.icon}
                    <span data-id="element-90">{tab.label}</span>
                  </Link>
                  {currentPath === tab.path && !location.pathname.includes('/project/') && <motion.div layoutId="active-tab" className={`absolute inset-0 rounded-2xl ${getActiveTabColor()} bg-opacity-50`} transition={{
                type: 'spring',
                stiffness: 400,
                damping: 30
              }} data-id="element-91" />}
                </motion.div>)}
              <AnimatePresence data-id="element-92">
                {location.pathname.includes('/project/') && <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: 20
              }} className="relative" data-id="element-93">
                    <div className="px-4 py-2 rounded-2xl text-base font-medium flex items-center relative z-10 text-amber-700" data-id="element-94">
                      <span className="truncate max-w-[300px]" data-id="element-95">
                        {projectName}
                      </span>
                    </div>
                    <motion.div layoutId="active-tab" className="absolute inset-0 rounded-2xl bg-amber-100 bg-opacity-50" transition={{
                  type: 'spring',
                  stiffness: 400,
                  damping: 30,
                  mass: 0.8
                }} data-id="element-96" />
                  </motion.div>}
              </AnimatePresence>
            </LayoutGroup>
          </nav>
          <div className="flex items-center space-x-4" data-id="element-97">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={handleContactClick} className="bg-[#0E7AFE] text-white px-3 sm:px-5 py-2 rounded-full flex items-center space-x-2 shadow-sm transition-all duration-300 hover:shadow-md hover:bg-blue-600" data-id="element-98">
              <MailIcon className="w-4 h-4" data-id="element-99" />
              <span className="hidden sm:inline" data-id="element-100">Contact Me</span>
            </motion.button>
          </div>
        </div>
      </div>
    </motion.header>;
};
export default Header;